

















































































































































































import { Component, Vue } from "vue-property-decorator";
import TaxObligationDTO from "@/dto/tax/TaxObligationDTO";
import { getTaxReportFormLabel } from "@/constants/TaxReportForm";
import { getTaxObligationLiabilityTypeLabel } from "@/constants/TaxObligationLiabilityType";
import TaxObligationPayload from "@/dto/tax/TaxObligationPayload";
import TaxObligationCommentPayload from "@/dto/tax/TaxObligationCommentPayload";
import TaxObligationService from "@/services/TaxObligationService";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import moment from "moment";
import { CounterpartyType } from "@/constants/CounterpartyType";
import { YEARS } from "@/constants/DateTimeConstants";
import SelectOption from "@/components/common/SelectOption";
import { TaxObligationStatus } from "@/constants/TaxObligationStatus";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import AddLedgerRecordModal from "@/components/admin/tax/AddLedgerRecordModal.vue";
import AddReconciliationRecordModal from "@/components/admin/tax/AddReconciliationRecordModal.vue";

@Component({
  components: {
    AddLedgerRecordModal,
    AddReconciliationRecordModal,
    PortalTextarea
  }
})
export default class TaxObligation extends Vue {
  
  taxObligation: TaxObligationDTO | null = null;
  assignee: SublimeEmployeeDTO | null = null;
  commentPayload: TaxObligationCommentPayload = new TaxObligationCommentPayload();

  get id(): number {
    return Number.parseInt(this.$route.params.id);
  }

  get sortedComments() {
    if (!this.taxObligation || !this.taxObligation.comments) return [];
    return [...this.taxObligation.comments].sort((a, b) => 
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  get sortedLedger() {
    if (!this.taxObligation || !this.taxObligation.ledger) return [];
    return [...this.taxObligation.ledger].sort((a, b) => a.order - b.order);
  }

  get latestReconciliation() {
    if (!this.taxObligation || !this.taxObligation.reconciliationRecords || this.taxObligation.reconciliationRecords.length === 0) {
      return null;
    }
    return [...this.taxObligation.reconciliationRecords].sort((a, b) => {
      return new Date(b.verificationDate).getTime() - new Date(a.verificationDate).getTime();
    })[0];
  }

  mounted(): void {
    this.loadEvent();
  }

  loadEvent(): void {
    Application.startLoading();
    TaxObligationService.getTaxObligation(this.id).then(
      res => {
        this.taxObligation = res.data;
        
        if (this.taxObligation.assigneeId) {
          this.assignee = {
            id: this.taxObligation.assigneeId,
            firstName: this.taxObligation.assigneeName ? this.taxObligation.assigneeName.split(' ')[0] : '',
            lastName: this.taxObligation.assigneeName && this.taxObligation.assigneeName.split(' ')[1] ? this.taxObligation.assigneeName.split(' ').slice(1).join(' ') : ''
          } as any;
        } else {
          this.assignee = null;
        }

        Application.stopLoading();
      },
      err => processError(err, this)
    );
  }

  public onAssigneeSelected(employee: SublimeEmployeeDTO | null): void {
    // Left for potential future use or just cleanup if truly unneeded. 
    // Since it was in the template and we removed the template part, 
    // we can remove the logic that updates 'form' which is now gone.
    this.assignee = employee;
  }

  public getTaxReportFormLabel(type: any): string {
    return getTaxReportFormLabel(type);
  }

  public getTaxObligationLiabilityTypeLabel(type: any): string {
    return getTaxObligationLiabilityTypeLabel(type);
  }
  
  public getFullPeriod(e: TaxObligationDTO): string {
    if(!e.year){
      return '-';
    } else if ((!e.period || e.period === 'FULL_YEAR' || e.period === 'FISCAL_YEAR') && !!e.year){
      return e.year.toString();
    } else {
      return (this as any).$stringUtils.formatPeriod(e.period) + ' ' + e.year;
    }
  }

  get yearOptions() {
    return YEARS.map(year => SelectOption.builder().title(`${year}`).value(year).build());
  }

  get statusClass(): string {
    if (!this.taxObligation) return '';
    const status = this.taxObligation.status as any;
    switch (status) {
      case 'COMPLETED':
        return 'badge-success';
      case 'OVERDUE':
        return 'badge-danger';
      case 'DUE_SOON':
        return 'badge-warning';
      case 'SCHEDULED':
        return 'badge-info';
      default:
        return 'badge-secondary';
    }
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY');
  }

  formatAmount(cents: number): string {
    return '$' + (cents / 100).toFixed(2);
  }

  formatDateTime(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY HH:mm');
  }

  addComment(): void {
    if (!this.commentPayload.comment.trim()) return;
    
    Application.startLoading();
    TaxObligationService.addComment(this.id, this.commentPayload).then(
      res => {
        Application.stopLoading();
        this.commentPayload = new TaxObligationCommentPayload();
        this.loadEvent();
      },
      err => processError(err, this)
    );
  }

  openAddLedgerRecordModal(): void {
    this.$modal.show('add-ledger-record-modal', { taxObligationId: this.id });
  }

  openAddReconciliationRecordModal(): void {
    this.$modal.show('add-reconciliation-record-modal', { taxObligationId: this.id });
  }
}
